import script from "./MakeWish.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeWish.vue?vue&type=script&setup=true&lang=js"

import "./MakeWish.vue?vue&type=style&index=0&id=ec279372&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec279372"]])

export default __exports__